<template>
  <div>
    <h3>Profile Settings</h3>
    <md-divider></md-divider>
    <settings-profile-form></settings-profile-form>
  </div>
</template>

<script>
import SettingsProfileForm from '../forms/SettingsProfileForm.vue'
export default {
  name: 'SettingsProfile',
  components: {
    SettingsProfileForm
  }
}
</script>

<style lang="scss" scoped>
  h3 {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/SettingsProfile.vue